import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://071d0bfdbebf8311fa82e0fd3b6efc23@o4511055045853184.ingest.de.sentry.io/4511055047491664",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Performance monitoring — sample 20% of transactions in production
  tracesSampleRate: import.meta.env.DEV ? 1.0 : 0.2,
  // Session Replay — capture 10% of sessions, 100% on error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  // Only send errors in production
  enabled: !import.meta.env.DEV,
  environment: import.meta.env.DEV ? "development" : "production",
});

export default Sentry;
